module.exports = __webpack_public_path__ + "static/img/image-4.02b8a5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new_feature/dashboard/image-4.png
// module id = gp1D
// module chunks = 1